/**
 * Protected Route for Cognito Authentication
 * Checks for cognitoAccessToken in localStorage
 */

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from '../../utils/cognitoAuthService';

const CognitoProtectedRoute = () => {
  // Check if user has Cognito access token
  if (!isAuthenticated()) {
    // Redirect to cognito auth page if not authenticated
    return <Navigate to="/cognito-auth" replace />;
  }

  // Render child routes if authenticated
  return <Outlet />;
};

export default CognitoProtectedRoute;
